<template>
  <div class="collection">
    <a-table :data-source="goods.list" style="margin-top: 20px;" rowKey="id" :pagination="pagination" @change="onPaginationChange">
      <a-table-column key="goods" title="商品名称" data-index="time_str">
        <template slot-scope="text, record">
          <div class="goods" @click="handleDetail(record)">
            <img :src="record.goods_img" class="goods-img"/>
            <div style="display: flex;flex-direction: column;justify-content: space-between;">
              <div class="goods-title">{{ record.goods_title }}</div>
              <div style="display: flex;">
                <div class="goods-price">券后价<span style="font-size: 16px;">{{ record.cost_price }}</span></div>
                <div class="goods-oprice">原价<span style="font-size: 16px;">{{ record.price }}</span></div>
              </div>
            </div>
          </div>
        </template>
      </a-table-column>
      <a-table-column key="commission" title="佣金" data-index="commission"/>
      <a-table-column key="action" title="操作">
        <template slot-scope="text, record">
        <span style="font-size: 20px;">
          <a-tooltip placement="top">
            <template slot="title">
              <span>加入橱窗</span>
            </template>
            <a  @click="() => onAdd(record)"><a-icon type="folder-add"/></a>
          </a-tooltip>
          <a-tooltip placement="top">
            <template slot="title">
              <span>删除收藏</span>
            </template>
            <a style="color: #ff4242;margin-left: 12px;" @click="() => onDelete(record)"><a-icon type="delete"/></a>
          </a-tooltip>
        </span>
        </template>
      </a-table-column>
    </a-table>
    <zy-add-window-dialog ref="addWindow" />
  </div>
</template>

<script>
import { fetchCollections, deleteCollection } from "@/api/goods-list";
import ZyAddWindowDialog from "@/components/zy-add-window-dialog/index.vue";
export default {
  name: "mine-collection",
  components: {
    ZyAddWindowDialog
  },
  props: {
    pvd: String
  },
  data() {
    return {
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
      goods: [],
    }
  },
  mounted() {
    this.fetchGoods()
  },

  methods: {
    onSearch() {

    },
    fetchGoods() {
      fetchCollections({
        p: `${this.pagination.current}`,
        size: `${this.pagination.pageSize}`
      }, this.pvd).then(res => {
        console.log(res)
        this.goods = res
        this.pagination.total = res.total
      })
    },
    onAdd(item) {
      console.log(item)
      this.$refs.addWindow.show({good_id: item.gid, provider: this.pvd})
    },
    handleDetail(item) {
      console.log(item)
      const url = this.$router.resolve({
        path: '/goods-detail',
        query: {
          id: item.gid,
          pvd: item.type,
        }
      })
      window.open(url.href, '_blank')
    },
    onDelete(item) {
      console.log(item)
      const that = this
      this.$confirm({
        title: '删除提示',
        content: '确认删除该商品？删除后无法恢复。',
        okType: 'danger',
        onOk() {
          deleteCollection({id: item.id}, that.pvd).then(res => {
            console.log(res)
            that.fetchGoods()
          })
        },
        onCancel() {},
      });
    },
    onPaginationChange(pagination) {
      console.log(pagination, this.pagination)
      this.pagination = pagination
      this.fetchGoods()
    }
  }
}
</script>

<style scoped lang="scss">
.collection {

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    font-weight: 500;
    color: #333333;
    line-height: 22px;

    .tag {
      width: 3px;
      height: 15px;
      background: #FA6400;
      margin-right: 4px;
    }

  }

  .goods {
    display: flex;
    cursor: pointer;

    .goods-img {
      width: 72px;
      height: 72px;
      border-radius: 8px;
      margin-right: 8px;
    }

    .goods-title {
      font-size: 14px;
      color: #000000;
      line-height: 30px;
    }

    .goods-price {
      font-size: 11px;
      font-weight: 500;
      color: #FF4242;
      line-height: 16px;
    }

    .goods-oprice {
      font-size: 11px;
      font-weight: 500;
      color: #C0C0C0;
      line-height: 16px;
      margin-left: 8px;
      text-decoration: line-through;
    }
  }
}
</style>
